export const isAbsoluteURL = (url: string): boolean =>
  /^(?:[a-z]+:)?\/\//i.test(url);
